/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StoreManagementCreateItemResponse } from './StoreManagementCreateItemResponse';

export type StoreManagementCreateItemResponseApiRespoonse = {
    data?: StoreManagementCreateItemResponse;
    status?: StoreManagementCreateItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace StoreManagementCreateItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

